import PropTypes from 'prop-types';
import styles from './FJImageEnhancerFileList.module.less';
import DeleteIcon from '../../../assets/svg/delete-x.svg?react';
import FJVerticalScroller from '../../../common/components/FJScroller/FJVerticalScroller';
import FJPreviewBox from '../../../common/components/FJPreviewBox/FJPreviewBox';
import FJTextWithEllipsisParent from '../../../common/components/FJTextWithEllipsis/FJTextWithEllipsisParent';
import FJGenerateStatus from '../../../common/components/FJGenerateStatus/FJGenerateStatus';
import FJToolTip from '../../../common/components/FJToolTip/FJToolTip';
import FJLocalStore from '../../../store/FJLocalStore';
import FlipList from '../../../store/FJFlipList';
import { useRef, useEffect } from 'react';
import FJConstant from '../../../constants/FJConstant';
import classNames from 'classnames';
const ANIMATION_DURATION = 120;

const FJImageEnhancerFileList = props => {
    const { deleteImage, uploadImageList, upscale } = props;
    const flipListRef = useRef(FlipList);
    const scrollRef = useRef(null);
    /**
     * @desc 记录children位置数据
     * @param {*} id
     * @returns
     */
    const createNewFlipList = () => {
        if (!scrollRef.current.getScroller()) return;
        //记录动画
        const listenChildren = [...scrollRef.current.getScroller().children];
        //列表
        flipListRef.current = new FlipList(listenChildren, ANIMATION_DURATION, null, 0);
        flipListRef.current.recordFirst();
    };
    useEffect(() => {
        createNewFlipList();
        return () => {
            flipListRef.current?.play(() => flipListRef.current?.recordFirst());
        };
    }, [uploadImageList.length]);
    const _getImagePixelString = item => {
        const { width, height } = item;
        return `${width} * ${height} > ${Math.floor(width * upscale)} * ${Math.floor(height * upscale)} px`;
    };

    const _render = () => {
        return (
            <FJVerticalScroller className={styles.scroll} ref={scrollRef}>
                {uploadImageList.map(item => {
                    return (
                        <div className={styles.item} key={item.name + item.id}>
                            <div className={styles.image_box}>
                                <img className={styles.item_img} src={item.src} alt='' loading='lazy' />
                                <FJPreviewBox className={styles.mask} imageInfo={item} />
                            </div>
                            <div className={styles.item_info}>
                                <FJTextWithEllipsisParent className={styles.item_info_name} text={item.name} />
                                {item.taskStatus === FJConstant.DEFAULT && (
                                    <span className={styles.item_info_size}>{_getImagePixelString(item)}</span>
                                )}
                            </div>
                            <FJToolTip title={FJLocalStore._('remove')}>
                                <div
                                    className={classNames(styles.item_del, {
                                        [styles.item_del_hide]: item.taskStatus !== FJConstant.DEFAULT,
                                    })}
                                    onClick={() => {
                                        deleteImage(item);
                                    }}
                                >
                                    <DeleteIcon />
                                </div>
                            </FJToolTip>
                            <FJGenerateStatus
                                className={styles.item_status_box}
                                taskStatus={item.taskStatus}
                                type={FJConstant.SMALL}
                                currentQueue={item.currentQueue}
                                queueNumber={item.queueNumber}
                            />
                        </div>
                    );
                })}
            </FJVerticalScroller>
        );
    };
    return <>{_render()}</>;
};
FJImageEnhancerFileList.propTypes = {
    deleteImage: PropTypes.func,
    uploadImageList: PropTypes.array,
    upscale: PropTypes.number,
};
export default FJImageEnhancerFileList;
